import { render, staticRenderFns } from "./ItemsVoucher.vue?vue&type=template&id=34542ddb&"
import script from "./ItemsVoucher.vue?vue&type=script&lang=js&"
export * from "./ItemsVoucher.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports